import { Link, Navigate, Route, Routes } from 'react-router-dom';

import { useAuth } from './auth/AuthContext';
import { missingConfig } from './config';
import { ApiKeys } from './pages/ApiKeys';
import { Billing } from './pages/Billing';
import { ConnectorJob } from './pages/ConnectorJob';
import { GenerateJob } from './pages/GenerateJob';
import { GithubCallback } from './pages/GithubCallback';
import { SignIn } from './pages/SignIn';
import { WebhookJob } from './pages/WebhookJob';

function SetupNeeded() {
  return (
    <main className="auth-page">
      <div className="auth-card">
        <h1>Configuration missing</h1>
        <p>This build has no backend configured. Set:</p>
        <ul className="mono">
          {missingConfig.map((name) => (
            <li key={name}>{name}</li>
          ))}
        </ul>
      </div>
    </main>
  );
}

function Shell({ children }: { children: React.ReactNode }) {
  const { user, signOut } = useAuth();

  return (
    <div className="shell">
      <header className="topbar">
        <Link to="/" className="topbar-brand">
          ETL Integrator
        </Link>
        <nav className="topbar-nav">
          <Link to="/connector">Connector</Link>
          <Link to="/webhook">Webhooks</Link>
          <Link to="/billing">Billing</Link>
          <Link to="/api-keys">API keys</Link>
        </nav>
        <div className="topbar-user">
          {user && (
            <>
              <span className="muted small">{user.email}</span>
              <button className="btn btn--ghost" onClick={signOut}>
                Sign out
              </button>
            </>
          )}
        </div>
      </header>
      {children}
    </div>
  );
}

export function App() {
  const { user, loading } = useAuth();

  if (missingConfig.length > 0) return <SetupNeeded />;
  if (loading) return <p className="muted page">Loading…</p>;
  if (!user) return <SignIn />;

  return (
    <Shell>
      <Routes>
        <Route path="/" element={<GenerateJob />} />
        <Route path="/connector" element={<ConnectorJob />} />
        <Route path="/webhook" element={<WebhookJob />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/api-keys" element={<ApiKeys />} />
        <Route path="/github/callback" element={<GithubCallback />} />
        <Route path="/github/authorized" element={<GithubCallback />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}
